<template lang="html">
  <v-container fluid style="position: absolute">
    <v-row>
      <v-col class="xs-12">
        <v-card>
          <v-toolbar>
            <v-btn to="/ai-dashboard/wp-similar">
              {{$t('AiDashboard.Similarity.Label')}}
            </v-btn>
            <v-btn to="/ai-dashboard/wp-order">
              {{$t('AiDashboard.Order.Label')}}
            </v-btn>
            <v-btn to="/ai-dashboard/wp-country">
              {{$t('AiDashboard.Country.Label')}}
            </v-btn>
          </v-toolbar>
          <router-view></router-view>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AIDashboard'
}
</script>

<style lang="css" scoped>
</style>
